import {Col, Row} from "antd";
import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";
import CreateUser from "./CreateUser";
import {useState} from "react";

export default function SubHeader() {
    const [open,setOpen]=useState(false)
    const handleOpen = () => {
        setOpen(true)
    }
    const handleClose = () => {
        setOpen(false)
    }
    return (
        <section>
            <Row justify={'space-between'}>
                <Col>
                    <h4>Les utilisateurs</h4>
                </Col>
                <Col>
                    <Button variant='contained' color='primary' startIcon={<AddIcon/>} onClick={handleOpen}>
                        Créer
                    </Button>
                </Col>
            </Row>
            <CreateUser open={open} onClose={handleClose}/>
        </section>
    )
}